"use strict";
import { useMemo } from "react";
import { nativeOnChain } from "uniswap/src/constants/tokens";
import { UniverseChainId } from "uniswap/src/features/chains/types";
export default function useNativeCurrency(chainId) {
  return useMemo(
    () => {
      if (chainId) {
        return nativeOnChain(chainId);
      }
      const mainnetChainId = UniverseChainId.Mainnet;
      if (mainnetChainId) {
        return nativeOnChain(mainnetChainId);
      }
      return nativeOnChain(UniverseChainId.H2);
    },
    [chainId]
  );
}
